import { Injectable } from '@angular/core';
import { firstValueFrom } from 'rxjs';

import { EnvService, TtHttpClientService } from 'app/core/services';

@Injectable({ providedIn: 'root' })
export class DocumentTypesService {
  private documentTypes: string[] = [];

  constructor(
    private readonly http: TtHttpClientService,
    private readonly envService: EnvService
  ) {}

  async load(): Promise<void> {
    return firstValueFrom(this.http.get<string[]>(this.envService.api.documents.getDocumentTypes)).then(types => {
      this.documentTypes = types;
    });
  }

  get(): string[] {
    return this.documentTypes;
  }
}
